<script setup>
import Editor from '@toast-ui/editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import { defineEmits, defineProps, onMounted, ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: false,
    default: '',
  },
  viewMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const emit = defineEmits(['update:modelValue']);

const editor = ref();
onMounted(() => {
  const e = Editor.factory({
    el: editor.value,
    initialValue: props.modelValue,
    height: '500px',
    initialEditType: 'markdown',
    previewStyle: 'vertical',
    viewer: props.viewMode,
    events: {
      change: () => {
        emit('update:modelValue', e.getMarkdown())
      },
    },
  });
});
</script>

<template>
  <div>
    <div ref="editor"></div>
  </div>
</template>
